export default __webpack_public_path__ + "static/media/cardBg.9a1e38d7.png";